module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsMother@2x.c1d1411.webp";